import { Contact } from "@/models/Common";
import { Timeslot } from "@/models/JobsState";
import { Technician } from "@/models/Technician";
import moment, { Moment } from "moment";

export const DEFAULT_SLOT_DURATION = 120;

export const dateTimeFormatter = (timeslot: Partial<Timeslot>) : { date: string, time: string } => {
	const startTime : Moment = moment(timeslot.date).add(timeslot.start_time, 'minutes')
	const slotDuration = timeslot.duration || DEFAULT_SLOT_DURATION;
	const endTime : Moment = startTime.clone().add(slotDuration, 'minutes')
	return {
		date: startTime.format('ddd, MMM DD, YYYY'),
		time: `${startTime.format("h:mma")} - ${endTime.format("h:mma")}`
	}
}

export const fullNameFormatter = (contact: Contact | Technician) : string => {
	return `${contact.first_name} ${contact.last_name}`
}
